import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import OverviewContent from './OverviewContent.js';
import ProviderListings from '../../../components/listing/ProviderListings.js';
import Reviews from '../../../components/review/Reviews.js';
import { TabPane, a11yProps, StyledTab, StyledTabs } from '../../../components/Tabs.js';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    padding: '2rem 0',
  },
  appBar: {
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    boxShadow: 'none',
    borderBottom: `1px solid ${theme.palette.common.silver}`,
  }
}));

const TabsPanel = ({itemType, data, showReviews=false, showListings=false, selectedTab=1, handleChange}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.appBar}>
        <StyledTabs value={selectedTab} onChange={handleChange} aria-label="Tabs">
          <StyledTab label="Overview" aria-label="Overview tab selector" {...a11yProps(0)} />
          {showReviews ? (<StyledTab label="Reviews" aria-label="Reviews tab selector" {...a11yProps(1)} />) : null}
          {showListings ? (<StyledTab label="Listings" aria-label="Listings tab selector" {...a11yProps(2)} />) : null}
        </StyledTabs>
      </AppBar>
      <TabPane value={selectedTab} index={0}>
        <OverviewContent
          data={data}
        />
      </TabPane>
      {showReviews ? (
        <TabPane value={selectedTab} index={1}>
          <Reviews itemType={itemType} data={data}/>
        </TabPane>
      ) : null}
      {showListings ? (
        <TabPane value={selectedTab} index={2}>
          <ProviderListings providerUuid={data.uuid} />
        </TabPane>
      ) : null}
    </div>
  );
};

TabsPanel.propTypes = {
  itemType: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  showReviews: PropTypes.bool,
  showListings: PropTypes.bool,
  selectedTab: PropTypes.number,
  handleChange: PropTypes.func.isRequired,
};

export default TabsPanel;
